/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import { toast } from 'react-toastify';
import OrgAppAuthProviderForm from './OrgAppAuthProviderForm';
import { editOrgApplicationAuthProvider } from '../../../../../../../../services/organization/OrgAppAuthProvider';
import { getAllOrgApplicationAuthProviders } from '../../../../../../../../store/reducers/organization/orgAppAuthProvider/orgAppAuthProviderAction';

const OrgAppAuthProviderEdit = ({ handleClose, selectedOrgAppAuthProvider }) => {
    const dispatch = useDispatch()
    const handleSubmit = async ({ detailName, detailValue,assertionConsumerServiceURL }, { setSubmitting }) => {
        try {
            setSubmitting(true)
            await editOrgApplicationAuthProvider({
                organizationApplicationAuthProviderID: selectedOrgAppAuthProvider.organizationApplicationAuthProviderID,
                organizationApplicationAuthProviderDetails: [
                    {
                        detailName: detailName,
                        detailValue: detailValue
                    }],
                    assertionConsumerServiceURL
            })
            toast.success('Organization Application Identity Provider was edited successfully');
            handleClose();
            await dispatch(getAllOrgApplicationAuthProviders()).unwrap();
            setSubmitting(false)
        } catch (error) {
            setSubmitting(false)
            toast.error(error?.response?.data?.error?.message);
        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Organization Application Identity Provider Edit</Typography>
            <Formik
                initialValues={{
                    detailName: selectedOrgAppAuthProvider.organizationApplicationAuthProviderDetails[0].detailName,
                    detailValue: selectedOrgAppAuthProvider.organizationApplicationAuthProviderDetails[0].detailValue,
                    assertionConsumerServiceURL: selectedOrgAppAuthProvider.assertionConsumerServiceURL ?? ""

                }}
                onSubmit={(
                    values, { setSubmitting }
                ) => {
                    handleSubmit(values, { setSubmitting })
                }
                }
            >
                {({ values, handleBlur, handleChange, setFieldValue, isSubmitting, errors, touched }) => (
                    <OrgAppAuthProviderForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched} />
                )}
            </Formik>
        </>
    )

}



export default OrgAppAuthProviderEdit;
